import type { ReactNode } from 'react';

interface PanelMobileHeaderProps {
  brand: ReactNode;
  open: boolean;
  onToggle: () => void;
}

export function PanelMobileHeader({ brand, open, onToggle }: PanelMobileHeaderProps) {
  return (
    <header className="panel-mobile-header">
      <button
        type="button"
        className="panel-menu-toggle"
        onClick={onToggle}
        aria-expanded={open}
        aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
      >
        <span className="panel-menu-toggle__icon" aria-hidden="true" />
      </button>
      <div className="panel-mobile-header__brand">{brand}</div>
    </header>
  );
}
